import React from "react";

const InstructionIcon = () => (
  <svg className="instruction-icon" x="0px" y="0px" viewBox="0 0 21.533 22">
    <path
      id="Path_63"
      data-name="Path 63"
      d="M22.606,11.664V1.772H7.746V20.228h6.836a.886.886,0,1,1,0,1.772H6.855a.891.891,0,0,1-.892-.886V.886A.891.891,0,0,1,6.855,0H23.5a.891.891,0,0,1,.892.886V11.664a.892.892,0,0,1-1.783,0ZM27.2,13.82a.9.9,0,0,0-1.263.074l-4.889,5.4L18.594,16.95a.9.9,0,0,0-1.263.03.883.883,0,0,0,.03,1.255l3.121,2.983a.879.879,0,0,0,.624.251h.03a.894.894,0,0,0,.624-.3l5.5-6.083A.887.887,0,0,0,27.2,13.82ZM19.337,5.168H11.313a.886.886,0,1,0,0,1.772h8.024a.886.886,0,1,0,0-1.772Zm.892,5.758a.891.891,0,0,0-.892-.886H11.313a.886.886,0,1,0,0,1.772h8.024A.891.891,0,0,0,20.229,10.926Zm-8.916,3.839a.886.886,0,1,0,0,1.772H13.69a.886.886,0,1,0,0-1.772Z"
      transform="translate(-5.963 0)"
      stroke="#ffffff"
      strokeWidth="0.4"
    />
  </svg>
);

export default InstructionIcon;
